<template>

  <div class="team-member">
    <img :src="thumbnail" :alt="memberName" class="thumbnail" />
    <h3>{{ memberName }}</h3>
    <p>{{ description }}</p>

    <router-link
        v-if=hasView
        :to="`/${memberName}`"
        class="learn-more">
      Learn More →
    </router-link>

  </div>

</template>

<script>
export default {
  props: {
    memberName: String,
    thumbnail: String,
    description: String,
    hasView: Boolean,
  },
};
</script>

<style>
.team-member {
  text-align: left;
  max-width: 200px;
}
.thumbnail {
  width: 100%;
  border-radius: 8px;
}
</style>